import { lazy } from "react";
import { settingSVG, webConfigurationSVG } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import( /* webpackChunkName: "settings" */ './components/EntryPoint'));
const WebConfiguretionLoader = lazy(() => import( /* webpackChunkName: "webConfiguretionLoader" */ './components/WebConfiguretionLoader'));

export const defaultPath = '/settings';

export const innerRoutes = [
    {
        path: `${defaultPath}/webConfiguration`,
        Component: WebConfiguretionLoader,
        exact: true,
        icon: webConfigurationSVG,
        title: {
            key: 'web',
            plural: false
        },
        subTitle: {
            key: 'modify_the_web_settings',
            plural: false
        }
    }
];

const Settings = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: settingSVG,
    title: {
        key: 'settings',
        plural: false
    },
    subTitle: {
        key: 'modify_the_web_settings',
        plural: false
    },
    innerRoutes: innerRoutes,
    pathChilds: innerRoutes.map(e => e.path),
    availableSubMenu: true
};

export default Settings;
